import { render } from "./DocumentListView.vue?vue&type=template&id=e216318a&scoped=true&ts=true"
import script from "./DocumentListView.vue?vue&type=script&lang=ts"
export * from "./DocumentListView.vue?vue&type=script&lang=ts"

import "./DocumentListView.vue?vue&type=style&index=0&id=e216318a&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e216318a"]])

export default __exports__